import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiCheckCircle } from 'react-icons/fi';
import { ExamsResolutionAnswerKey } from './exams-resolution-answer-key';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import IconExams from '@/components/custom/icons/IconExams';
import { Card, CardBody, CardBodyContent, CardBodyHeader, CardBodyHeaderContent, CardContent, CardFooter, CardIcon, CardIconImg, CardKpi, CardKpiGrid, CardKpiTitle, CardTitle } from '@/components/ui/card';
import { Badge, BadgeTruncate } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Sheet, SheetBody, SheetContent } from '@/components/ui/sheet';

export function ExamsResolutionCard({ exam }) {
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);

  const isAcceptingAnswers = exam.status === 'accepting_answers';
  const isExamDone = exam.status === 'approved' || exam.status === 'disapproved';

  const BottomButton = () => {
    if (isAcceptingAnswers || !exam?.['abble-to-retry']) {
      return (
        <Button
          variant="outline"
          size="sm"
          fullWidth
          asChild
        >
          <Link to={`/avaliacoes/sobre/${exam?.id}`}>{t('exams.accessExam')}</Link>
        </Button>
      );
    }

    if (isExamDone) {
      return (
        <Button
          variant="outline"
          size="sm"
          fullWidth
          onClick={() => setShowModal(true)}
        >
          {t('button.answerKey')}
        </Button>
      );
    }

    return (
      <Button
        size="sm"
        fullWidth
        disabled
      >
        {t('button.answerKey')}
      </Button>
    );
  };

  function ExamStatusBadge({ exam }) {
    const getBadgeProps = () => {
      switch (exam.status) {
        case 'approved':
          return {
            variant: 'success',
            text: t('exams.statusInApproved')
          };
        case 'review':
          return {
            variant: 'warning',
            text: t('exams.statusInAnalysis')
          };
        case 'disapproved':
          return {
            variant: 'danger',
            text: t('exams.statusInDisapproved')
          };
        case 'accepting_answers':
          return {
            variant: 'warning',
            text: 'Aceitando respostas'
          };
        default:
          return {
            variant: 'danger',
            text: t('exams.statusUnrealized')
          };
      }
    };

    const { variant, text } = getBadgeProps();

    return (
      <Badge
        size="xs"
        variant={variant}
      >
        {text}
      </Badge>
    );
  }

  return (
    <Card
      hover
      isWarning={isAcceptingAnswers}
    >
      <CardContent>
        <CardIcon>
          <CardIconImg>
            <IconExams />
          </CardIconImg>
        </CardIcon>

        <CardBody>
          <CardBodyHeader>
            <CardBodyHeaderContent>
              <CardTitle title={exam?.title}>{exam?.title}</CardTitle>
            </CardBodyHeaderContent>

            <ExamStatusBadge exam={exam} />
          </CardBodyHeader>

          <CardBodyContent>
            <BadgeTruncate
              oneLine
              variant="primary-light"
              size="sm"
              items={exam?.taxonomies}
              initialCount={2}
            />

            <CardKpiGrid>
              <CardKpi title={t('exams.questions')}>
                <CardKpiTitle>{t('textsCommon.questions')}</CardKpiTitle>
                <FiCheckCircle /> {exam?.['question-count']}
              </CardKpi>
              {exam?.['published-at'] !== null && (
                <CardKpi title={t('exams.labelPublishedAt')}>
                  <CardKpiTitle>{t('exams.labelPublishedAt')}</CardKpiTitle>
                  {moment(exam?.['published-at']).format(t('datesForm.formatDate'))}
                </CardKpi>
              )}
            </CardKpiGrid>
          </CardBodyContent>
        </CardBody>
      </CardContent>

      <CardFooter>
        <BottomButton />
      </CardFooter>

      <Sheet
        open={showModal}
        onOpenChange={setShowModal}
      >
        <SheetContent size="md">
          <SheetBody className="pb-6 pt-12">
            <ExamsResolutionAnswerKey
              examId={exam?.id}
              amountQuestions={exam['question-count']}
            />
          </SheetBody>
        </SheetContent>
      </Sheet>
    </Card>
  );
}
